import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../cn.js';
export const Input = forwardRef(function Input({ className, invalid, ...rest }, ref) {
    return (_jsx("input", { ref: ref, "aria-invalid": invalid || undefined, className: cn('h-10 w-full rounded-md border bg-surface-container-lowest px-3 text-sm text-on-surface', 'placeholder:text-on-surface-variant', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary', invalid ? 'border-error' : 'border-outline', className), ...rest }));
});
//# sourceMappingURL=Input.js.map